import { FieldList } from '../FieldList/FieldList';
import type { LabelValueField } from '../LabelValueFields/LabelValueFields';

interface Props {
  licences?: Array<{
    name: string;
    issuingOrganisation?: string;
    isVerified?: boolean;
    labelValueFields?: LabelValueField[];
  }>;
}

export const Licences = ({ licences }: Props) => (
  <FieldList
    icon="document"
    iconTone="positive"
    descriptionSize="smallMobile"
    fields={
      licences
        ? licences.map(
            ({ name, issuingOrganisation, isVerified, labelValueFields }) => ({
              heading: name,
              subHeading: issuingOrganisation,
              isVerified,
              labelValueFields,
            }),
          )
        : []
    }
  />
);
